import { Button, useTheme } from "@mui/material";

interface TabButtonProps {
  label: string;
  onClick: () => void;
  active: boolean;
}
const TabButton = ({ label, onClick, active }: TabButtonProps) => {
  const theme = useTheme();
  return (
    <Button
      value="left"
      sx={{
        margin: "none",
        borderBottom: active
          ? `3px solid ${theme.palette.primary.main}`
          : "3px solid transparent",
        borderRadius: "0",
        padding: "0",
        fontSize: "24px",
        fontWeight: "bold",
        color: active ? "black" : theme.palette.grey[500],
        '@media (max-width: 450px)': {
          fontSize: '17px',
        },
      }}
      onClick={() => {
        onClick();
      }}
      variant="text"
      color="inherit"
    >
      {label}
    </Button>
  );
};
export default TabButton;
